export function isFieldEmpty(value?: string) {
  return !value?.trim().length ? 'ops! sua resposta está vazia' : undefined;
}
